import { render, staticRenderFns } from "./PconList.vue?vue&type=template&id=53c82b22&scoped=true&"
import script from "./PconList.vue?vue&type=script&lang=js&"
export * from "./PconList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c82b22",
  null
  
)

export default component.exports